export default defineNuxtPlugin(() => {
  if (import.meta.client) {
    const { setupRouteWatcher } = useIntercomNavigation()
    setupRouteWatcher()
  }
})
